import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Block } from '../../../../../abstract/Block.js';
import { classNames } from '../../lib/classNames.js';
export class LrBtnUi extends Block {
  constructor() {
    super();
    this._iconReversed = false;
    this._iconSingle = false;
    this._iconHidden = false;
    this.init$ = _objectSpread(_objectSpread({}, this.init$), {}, {
      text: '',
      icon: '',
      iconCss: this._iconCss(),
      theme: null
    });
    this.defineAccessor('active', active => {
      if (active) {
        this.setAttribute('active', '');
      } else {
        this.removeAttribute('active');
      }
    });
  }
  _iconCss() {
    return classNames('icon', {
      icon_left: !this._iconReversed,
      icon_right: this._iconReversed,
      icon_hidden: this._iconHidden,
      icon_single: this._iconSingle
    });
  }
  initCallback() {
    super.initCallback();
    this.sub('icon', iconName => {
      this._iconSingle = !this.$.text;
      this._iconHidden = !iconName;
      this.$.iconCss = this._iconCss();
    });
    this.sub('theme', theme => {
      if (theme !== 'custom') {
        this.className = theme;
      }
    });
    this.sub('text', txt => {
      this._iconSingle = false;
    });
    this.setAttribute('role', 'button');
    if (this.tabIndex === -1) {
      this.tabIndex = 0;
    }
    if (!this.hasAttribute('theme')) {
      this.setAttribute('theme', 'default');
    }
  }
  set reverse(val) {
    if (this.hasAttribute('reverse')) {
      this.style.flexDirection = 'row-reverse';
      this._iconReversed = true;
    } else {
      this._iconReversed = false;
      this.style.flexDirection = null;
    }
  }
}
LrBtnUi.bindAttributes({
  text: 'text',
  icon: 'icon',
  reverse: 'reverse',
  theme: 'theme'
});
LrBtnUi.template = /* HTML */"\n  <lr-icon size=\"20\" set=\"className: iconCss; @name: icon;\"></lr-icon>\n  <div class=\"text\">{{text}}</div>\n";